import React from 'react';
import '../FishFinderBuilder.css';

const LinkListPage = () => {
  const containerStyle = {
    width: '100%',
    margin: '0 auto',
    padding: 0,
    backgroundColor: '#000000',
    minHeight: '100vh'
  };

  const iframeStyle = {
    width: '100%',
    border: 'none',
    minHeight: '100vh',
    display: 'block'
  };

  return (
    <div style={containerStyle}>
      <iframe
        src="/blackfriday2025deals.html"
        style={iframeStyle}
        title="Black Friday 2025 Deals"
        scrolling="auto"
      />
    </div>
  );
};

export default LinkListPage;

